module.exports = __webpack_public_path__ + "img/user2.8c74a0e0.png";